import { render, staticRenderFns } from "./LoginLink.vue?vue&type=template&id=2198bbbf&scoped=true"
import script from "./LoginLink.vue?vue&type=script&lang=js"
export * from "./LoginLink.vue?vue&type=script&lang=js"
import style1 from "./LoginLink.vue?vue&type=style&index=1&id=2198bbbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198bbbf",
  null
  
)

export default component.exports